"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.themeOptions = void 0;
/* eslint-disable @typescript-eslint/no-empty-interface */
const styles_1 = require("@mui/material/styles");
const colors_1 = require("./colors");
__exportStar(require("./colors"), exports);
const defaultTheme = (0, styles_1.createTheme)();
var TypographyKey;
(function (TypographyKey) {
    TypographyKey["display48"] = "display48";
    TypographyKey["title20"] = "title20";
    TypographyKey["subTitle18"] = "subTitle18";
    TypographyKey["body16"] = "body16";
    TypographyKey["body15"] = "body15";
    TypographyKey["body14"] = "body14";
    TypographyKey["body13"] = "body13";
    TypographyKey["caption12"] = "caption12";
    TypographyKey["caption10"] = "caption10";
})(TypographyKey || (TypographyKey = {}));
const customPalette = Object.assign(Object.assign({}, defaultTheme.palette), colors_1.colors);
const fontFamily = [
    "Spoqa Han Sans Neo",
    "Pretendard",
    "Poppins",
    "-apple-system",
    "sans-serif",
].join(", ");
const customTypography = {
    fontFamily,
    display48: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: 48,
    },
    title20: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: 20,
    },
    subTitle18: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 18,
    },
    body16: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 16,
    },
    body15: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 15,
    },
    body14: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 14,
    },
    body13: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 13,
    },
    caption12: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 12,
    },
    caption10: {
        fontFamily,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: 10,
    },
};
const customBreakpoints = {
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        mobile: 0,
        tablet: 768,
        laptop: 1280,
    },
};
exports.themeOptions = {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    WebkitFontSmoothing: "auto",
                    scrollbarWidth: "none",
                },
                "input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active": {
                    WebkitBoxShadow: "0 0 0 500px white inset !important",
                },
                "::-webkit-scrollbar": {
                    width: 2,
                    height: 0,
                },
                "::-webkit-scrollbar-button": {
                    background: "#ccc",
                },
                "::-webkit-scrollbar-track-piece": {
                    background: "#888",
                },
                "::-webkit-scrollbar-thumb": {
                    background: "#eee",
                },
            },
        },
    },
    palette: customPalette,
    typography: Object.assign(Object.assign({}, customTypography), { htmlFontSize: 16 }),
    breakpoints: Object.assign({}, customBreakpoints),
};
exports.theme = (0, styles_1.createTheme)(exports.themeOptions);
